import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import React, { FC } from "react";
import { css } from "styled-components";

interface OwnProps extends WidgetProps {
    extendedStyles?: FooterContainerStyles;
}

export interface FooterContainerStyles {
    logoGridItem?: GridItemProps;
    container?: GridContainerProps;
    contentItem?: GridItemProps;
}

export const footerContainerStyles: FooterContainerStyles = {
    logoGridItem: {
        width: 12,
        css: css`
            width: 100%;
            display: flex;
            justify-content: center;
            img {
                height: 78px;
            }
        `,
    },
    container: {
        css: css`
            min-height: 100%;
            display: flex;
        `,
    },
    contentItem: {
        css: css`
            width: 25%;
            & a > span {
                color: #333 !important;
                line-height: 2;
            }
            & a:hover {
                text-decoration: underline;
            }
        `,
    },
};

const FooterNavigation: FC<OwnProps> = ({ id, extendedStyles }) => {
    const [styles] = React.useState(() => mergeToNew(footerContainerStyles, extendedStyles));
    return (
        <StyledWrapper>
            <GridContainer {...styles.container}>
                <GridItem width={[12, 12, 6]} {...styles.contentItem}>
                    <Zone contentId={id} zoneName="FirstColumn" />
                </GridItem>
                <GridItem width={[12, 12, 6]} {...styles.contentItem}>
                    <Zone contentId={id} zoneName="SecondColumn" />
                </GridItem>
                <GridItem width={[12, 12, 6]} {...styles.contentItem}>
                    <Zone contentId={id} zoneName="ThirdColumn" />
                </GridItem>
                <GridItem width={[12, 12, 6]} {...styles.contentItem}>
                    <Zone contentId={id} zoneName="FourthColumn" />
                </GridItem>
            </GridContainer>
            <Zone contentId={id} zoneName="LogoContainer" />
        </StyledWrapper>
    );
};

const footerNavigation: WidgetModule = {
    component: FooterNavigation,
    definition: {
        group: "Footer",
    },
};

export default footerNavigation;
